import React, {useContext } from 'react';

// material-ui
import {Alert,Card, CardContent, Chip, Grid, Link, Typography, Table, TableBody, TableCell, TableContainer, TableRow, Stack } from '@mui/material/';
import { styled } from '@mui/material/styles';
import { CommentOutlined, EditOutlined, WatchLater, } from '@mui/icons-material/';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { blue} from '@mui/material/colors';
import LegalReferral from '../dataObjects/LegalReferral';
import { AuditorCommunicationContext } from '../view-archer';

interface Props {
    pendingReferrals?: LegalReferral[];
    editReferral: () => void;
}

const DashboardPendingReferrals = (props: Props) => {
   
    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: 'white',
            color: 'rgba(0, 0, 0, 0.87)',
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9',
            minWidth: 550,
        },
    }));

    const context = useContext(AuditorCommunicationContext);

    const setCurrentLetterCpfId = (cpfId: number) => {
        context.setCurrentLetterCpfId(cpfId);
    }

    const displayReferralDetailsDialog = (referral: LegalReferral) => {

        return (
            <Grid container className="referral-card">
                <Grid item xs={12} className="card-content">
                    {/* SUMMARY */}
                    <Grid container className="referral-section">
                        <Typography variant="subtitle2">
                            <u>SUMMARY: {referral.cpfId} {referral.filerName}</u>
                        </Typography>
                    </Grid>
                    <Grid container className="referral-section">
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={{ color: blue[800] }}>Issue Description</Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography variant="body2">{referral.issuesDescription}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container className="referral-section">
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={{ color: blue[800] }}>Relevant Background</Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography variant="body2">{referral.relevantBackground}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container className="referral-section">
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={{ color: blue[800] }}>Auditor Recommendation:</Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography variant="body2">{referral.auditorRecommendation}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container className="referral-section">
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" sx={{ color: blue[800] }}>Date Phone Call Made:</Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography variant="body2">{referral.callDate}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    return (
        <div>
            <Card className="dashboard-tile">
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container alignContent="center" justifyContent="space-between">
                                <Grid item>
                                    <Typography variant="subtitle1" color="blue">Pending Referrals {props.pendingReferrals && `(${props.pendingReferrals.length})`}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} >
                            {
                                props.pendingReferrals && props.pendingReferrals.length === 0 &&
                                <Alert severity="success" sx={{ margin: 2 }}>There are no pending Legal Referrals!</Alert>
                            }
                            {
                                props.pendingReferrals && props.pendingReferrals.length > 0 &&
                                <TableContainer sx={{ maxHeight: 265, m: 1 }} >
                                    <Table sx={{ minWidth: 650 }} aria-label="scheduled letters table">
                                        <TableBody>
                                                {
                                                    props.pendingReferrals?.map((referral) =>
                                                        <TableRow key={referral.id} >
                                                        <TableCell>
                                                            <Chip icon={<WatchLater />} label={referral.creationDate} color="success" variant="outlined" />
                                                        </TableCell>
                                                        <TableCell sx={{ textAlign: "left!important" }}>
                                                            <HtmlTooltip title={displayReferralDetailsDialog(referral)} placement="top-start">
                                                                <Typography variant="body2" className="is-clickable" onClick={props.editReferral}><b>{referral.cpfId} {referral.filerName}</b></Typography>
                                                            </HtmlTooltip>
                                                        </TableCell>
                                                        <TableCell sx={{ textAlign: "left!important" }}>
                                                            <Stack spacing={2}>
                                                                {
                                                                    referral.issues &&
                                                                    referral.issues.map((issue) =>
                                                                        <span key={issue.issueId} className="issue-link-text">
                                                                            <span className={issue.status} >{issue.issueTypeCode} {issue.header}</span>
                                                                            <Link onClick={() => setCurrentLetterCpfId(referral.cpfId)}>(<i>{issue.date}</i>)</Link>
                                                                        </span>
                                                                    )
                                                                }
                                                            </Stack>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Stack direction="row" spacing={1}>
                                                                <HtmlTooltip title={displayReferralDetailsDialog(referral)} placement="top-start">
                                                                    <CommentOutlined fontSize="small" />
                                                                </HtmlTooltip>
                                                                <EditOutlined fontSize="small" className="is-clickable" onClick={props.editReferral} />
                                                            </Stack>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            }
                            
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </div>

    )
}

export default DashboardPendingReferrals;